import {
  type AnchorHTMLAttributes,
  forwardRef,
  type MouseEvent,
  useContext,
} from 'react';

import { LinkHistoryContext } from './link_history_context';

export type LinkProps = Omit<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> & {
  to: string;
  replace?: boolean;
};

function isModifiedClick(event: MouseEvent<HTMLAnchorElement>): boolean {
  return (
    event.metaKey ||
    event.altKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.button !== 0
  );
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  function LinkComponent({ to, replace, onClick, target, ...rest }, ref) {
    const history = useContext(LinkHistoryContext);

    const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
      onClick?.(event);
      if (
        event.defaultPrevented ||
        isModifiedClick(event) ||
        (target && target !== '_self')
      ) {
        return;
      }
      event.preventDefault();
      if (replace) {
        history.replace(to);
      } else {
        history.push(to);
      }
    };

    return (
      <a ref={ref} href={to} target={target} onClick={handleClick} {...rest} />
    );
  },
);
